import React from 'react';
import {observer} from 'mobx-react';
import {useWidgetPortalConfig} from '../../../infrastructure/hooks/use-widget-portal-config';

export const StandAloneWidgetWrapper = observer(({controller, onWidgetVisible}) => {
  const {state, device, appState} = controller;
  const {settings, terms} = state;
  const {bootstrapSettings} = settings;
  const {isSmallView} = device;

  const widgetType = bootstrapSettings.widgetType;

  const appContext = {
    controller,
    device,
    terms,
    isSmallView,
    topBookmakerId: appState?.topBookmaker?.id || appState?.sponsoredBookmaker?.id,
  };

  const widgetConfig = useWidgetPortalConfig(widgetType, bootstrapSettings, appContext);

  if (!widgetConfig) {
    return null;
  }

  const {component: Component, props: widgetProps} = widgetConfig;

  const componentProps = {
    ...widgetProps,
    controller,
    onWidgetVisible,
    isSmallView
  };

  return <Component {...componentProps} />;
});
